import React from 'react'
import {Box, Link, LinkProps, Text, Image} from '@miro-site/core'
import styled, {css, useTheme} from 'styled-components'
import {useTranslation} from 'next-i18next'

const Container = styled(Box).attrs(({theme: {miroverseHighlighted}}) => ({
  $py: miroverseHighlighted.container.verticalPadding,
  $px: miroverseHighlighted.container.horizontalPadding,
  $styles: {
    borderRadius: miroverseHighlighted.container.radius,
    backgroundColor: miroverseHighlighted.container.background,
  },
}))``

const MiroverseTitle = styled(Text).attrs(({theme: {miroverseHighlighted}}) => ({
  as: miroverseHighlighted.title.as,
  $variant: miroverseHighlighted.title.variant,
  $styles: {
    fontWeight: miroverseHighlighted.title.fontWeight,
    color: miroverseHighlighted.title.color,
  },
}))({})

const ItemContainer = styled(Box).attrs(({theme: {miroverseHighlighted}}) => ({
  $styles: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingBottom: miroverseHighlighted.itemContainer.verticalPadding,
    paddingTop: miroverseHighlighted.itemContainer.verticalPadding,
  },
}))``

export const ItemLink = styled(Link)`
  display: block;
  &:focus {
    ${props => props.theme.normalizeStyles(props.theme.focus.outlines.withOffset)}
  }
`

type HeroBannerLinkProps = LinkProps & {lineBottom?: boolean}

const HeroBannerLink = styled(ItemLink)<HeroBannerLinkProps>`
  ${({theme: {miroverseHighlighted}, lineBottom = false}) =>
    lineBottom &&
    css`
      border-bottom: 1px solid ${miroverseHighlighted.itemContainer.link.dividerColor};
    `}
`

const ActionLink = styled(Link).attrs(({theme: {miroverseHighlighted}}) => ({
  $variant: miroverseHighlighted.actionLink.variant,
  $color: miroverseHighlighted.actionLink.color,
  $size: miroverseHighlighted.actionLink.size,
  withArrow: miroverseHighlighted.actionLink.withArrow,
}))`
  ${({theme: {normalizeStyles, miroverseHighlighted}}) =>
    normalizeStyles({
      fontSize: miroverseHighlighted.actionLink.fontSize,
      fontWeight: miroverseHighlighted.actionLink.fontWeight,
    })}
`

export const ItemDescription = styled(Text).attrs(({theme: {miroverseHighlighted}}) => ({
  $styles: {
    fontSize: miroverseHighlighted.itemContainer.itemDescription.fontSize,
    lineHeight: miroverseHighlighted.itemContainer.itemDescription.lineHeight,
    color: miroverseHighlighted.itemContainer.itemDescription.color,
  },
}))``
export const CategoryHeroBanner = (): React.ReactElement => {
  const {miroverseHighlighted} = useTheme()
  const {t} = useTranslation('common')
  return (
    <Container data-track-place="Hero Category Banner">
      <MiroverseTitle>
        {t('miroverse-section-in-category-menu-initial')} <br />
        {t('miroverse-section-in-category-menu-end')}
      </MiroverseTitle>
      <HeroBannerLink target="_blank" href={'/miroverse/'}>
        <ItemContainer>
          <Box $styles={{width: miroverseHighlighted.itemContainer.imageWidth}}>
            <Image
              name="miroverse-profiles"
              aria-hidden={true}
              src={
                'https://images.ctfassets.net/qop92tnevinq/6YEjAd5p8dQnQAFqjx3HAV/d6cc387f649b467cf7c37c5c230c143e/miroverse_banner_faces_small.png'
              }
            />
          </Box>
        </ItemContainer>
      </HeroBannerLink>
      <ActionLink target="_blank" href={'/miroverse/'}>
        {t('miroverse-cta-category-menu')}
      </ActionLink>
    </Container>
  )
}
